const header = document.querySelector('.js-header-ab');

if(header){

  const triggers = header.querySelectorAll('.js-submenu-trigger');
  const allDrawers = header.querySelectorAll('.js-submenu-drawer');

  // close all drawers

  const closeAllDrawers = () => {
    allDrawers.forEach(drawer => {
      drawer.classList.remove("active");
    })
  }

  /*triggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      const handle = trigger.getAttribute('data-submenu-trigger');
      const submenu = header.querySelector(`.js-submenu-drawer[data-submenu-drawer="${handle}"]`);

      // is open 
      if(submenu.classList.contains('active')){
        closeAllDrawers();
      }
      else { // is close
        closeAllDrawers();
        submenu.classList.add("active");
      }

    })
  })*/

  triggers.forEach(trigger => {
    const handle = trigger.getAttribute('data-submenu-trigger');
    const submenu = header.querySelector(`.js-submenu-drawer[data-submenu-drawer="${handle}"]`);

    let closeTimeout;

    const openMenu = () => {
      clearTimeout(closeTimeout);
      closeAllDrawers();
      submenu.classList.add('active');
    };

    const closeMenu = () => {
      closeTimeout = setTimeout(() => {
        submenu.classList.remove('active');
      }, 50); // Small delay prevents flickering
    };

    trigger.addEventListener('mouseenter', openMenu);
    submenu.addEventListener('mouseenter', () => clearTimeout(closeTimeout));

    trigger.addEventListener('mouseleave', closeMenu);
    submenu.addEventListener('mouseleave', closeMenu);
  });

  // search 
  const searchTrigger = header.querySelector('.js-search-ab-trigger');
  const searchBody = header.querySelector('.search-popdown__body');

  searchTrigger.addEventListener('click', () => {
    searchBody.classList.add('active');
  })

  // mobile drawer
  const drawerTrigger = header.querySelector('.js-ab-drawer-trigger');
  const drawer = header.querySelector('.js-ab-drawer');
  const drawerClose = header.querySelector('.js-ab-drawer-close');

  drawerTrigger.addEventListener('click', () => {
    drawer.classList.add('active');
  })

  drawerClose.addEventListener('click', () => {
    drawer.classList.remove('active');
  })

  // accordions
  const accordionTriggers = header.querySelectorAll('.js-ab-accordion-trigger');

  accordionTriggers.forEach(accordion => {
    accordion.addEventListener('click', () => {
      accordion.classList.toggle('active');
    })
  })
}